import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/locale/nl';
import 'vue2-datepicker/locale/fr';
import 'vue2-datepicker/locale/es';
@Component({
  name: 'bpc-time',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'date-picker': DatePicker,
  },
})
export default class Time extends mixins(AbstractField) {
  @Prop(String) readonly value: string;
  @Prop({ type: Boolean, default: true }) readonly tenantDefaultTime: boolean;

  get model(): string {
    return this.value;
  }
  set model(val: string) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }
  get hours(): number[] {
    // If we don't use the tenant configuration: full range 00–23
    if (!this.tenantDefaultTime) {
      return Array.from({ length: 24 }, (_, i) => i);
    }

    // if we use the tenant configuration: read start/end from the store
    const center = this.$store.getters['centerSettings/centerSettings'];
    const startHour = parseInt(center?.default_start_hour?.slice(0, 2) || '7', 10);
    const endHour = parseInt(center?.default_end_hour?.slice(0, 2) || '22', 10);

    const from = Math.min(startHour, endHour);
    const to = Math.max(startHour, endHour);

    return Array.from({ length: to - from + 1 }, (_, i) => from + i);
  }
}
